import { Injectable } from "@angular/core";
import {
    DefaultSystemBrowserOptions,
    InAppBrowser
} from "@capacitor/inappbrowser";
import { Capacitor } from "@capacitor/core";

@Injectable({
    providedIn: "root"
})
export class BrowserService {
    constructor() {}

    openLink(link: string) {
        // Simplified: match any Google Maps link for any TLD
        const isGoogleMaps =
            /https?:\/\/(www\.)?google\.[^\/]+\/maps/.test(link) ||
            /https?:\/\/(www\.)?maps\.google\.[^\/]+\//.test(link);

        if (isGoogleMaps) {
            window.open(link, "_system");
            return;
        }

        if (Capacitor.isNativePlatform()) {
            InAppBrowser.openInSystemBrowser({
                url: link,
                options: DefaultSystemBrowserOptions
            }).catch((error) => {
                console.error(error);
                // Fallback to window.open because some url's are not supported by InAppBrowser (like google maps on android)
                window.open(link, "_blank");
            });
        } else {
            window.open(link, "_blank");
        }
    }
}
